import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxDeliveryNotes from "../../util/remote/ajaxDeliveryNotes";
import PurchaseOrderDetailsModal from "./PurchaseOrderDetailsModal";
const ViewDeliveryNotes = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [deliveries, setDeliveries] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  // Fetching data
  const fetchDeliveryNotes = async () => {
    setLoading(true);
    const server_response = await ajaxDeliveryNotes.fetchDeliveryNotess({
      page,
    });
    setLoading(false);
    if (server_response.status === "OK") {
      setDeliveries(server_response.details.list);
      setMeta(server_response.details.meta.list_of_pages);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchDeliveryNotes();
  }, [page]);
  const setNextPageNumber = () => {
    if (page < meta.length) setPage(page + 1);
  };
  const setPreviousPageNumber = () => {
    if (page > 1) setPage(page - 1);
  };
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  // View details modal
  const [view_details, setView_details] = useStateCallback(false);
  const handleView_details = (data) => {
    setView_details(false, () =>
      setView_details(<PurchaseOrderDetailsModal data={data} />)
    );
  };
  return (
    <AppContainer title="Delivery Notes View">
      <div className="container-fluid">
        <Toaster />
        {view_details}
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/delievery_notes/create")}
            >
              Create Delivery Note
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card card-dashboard-calendar pb-0">
              <label className="main-content-label mb-2 pt-1">
                Organisation Delivery Notes
              </label>
              <span className="d-block tx-12 mb-2 text-muted">
                List of registered delivery notes
              </span>
              <table className="table table-striped table-hover table-responsive">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>Delivery No</th>
                    <th>Comment</th>
                    <th>Delivered By</th>
                    <th>good_recieved_no</th>
                    <th>Date</th>
                    <th>Created_by</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(deliveries) &&
                    deliveries.map((del, key) => (
                      <tr key={del.id}>
                        <td>{key + 1}</td>
                        <td>{del.delievery_reff_no}</td>
                        <td>{del.comment}</td>
                        <td>{del.Delivered_by || "No data"}</td>
                        <td>{del.good_recieved_no || "No data"}</td>
                        <td>{del.date_created}</td>
                        <td>{del.recieved_byID}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => handleView_details(del)}
                          >
                            <i className="fa fa-eye" /> Details
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {/* Pagination */}
              <nav className="mt-3" style={{ marginLeft: "30px" }}>
                <ul className="pagination">
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={setPreviousPageNumber}
                    >
                      Prev
                    </button>
                  </li>
                  {Array.isArray(meta) &&
                    meta.map((item) =>
                      page === item ? (
                        <li className="page-item active" key={item}>
                          <a className="page-link" href="#!">
                            {item}
                          </a>
                        </li>
                      ) : (
                        <li className="page-item" key={item}>
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => setPageNumber(e, item)}
                          >
                            {item}
                          </a>
                        </li>
                      )
                    )}
                  <li className="page-item">
                    <button className="page-link" onClick={setNextPageNumber}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewDeliveryNotes;
